import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';

import { getVideoIdSelector } from '../selectors';
import {
  videoAttachmentsFetchRequestAction,
  videoAttachmentsResetAction,
} from 'components/video-box/video-attachments/actions';
import { getVideoAttachmentsSelector } from 'components/video-box/video-attachments/selector';
import { Button } from 'components/button/index';
import { FileSize } from './fragments/file-size';

export const VideoAttachments = ({ className }) => {
  const videoId = useSelector(getVideoIdSelector);
  const attachments = useSelector(getVideoAttachmentsSelector);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (videoId) {
      dispatch(videoAttachmentsFetchRequestAction(videoId));
    }

    return () => {
      dispatch(videoAttachmentsResetAction());
    };
  }, [videoId, dispatch]);

  const downloadFile = (downloadUrl) => {
    window.open(downloadUrl);
  };

  const containerClassName = className ? ` ${className}` : '';

  return (
    <div className={`ct-video-attachments${containerClassName}`}>
      <ul className="ct-video-attachments__list" data-e2e="video-attachments">
        {attachments.map((item, index) => (
          <li key={index + item.downloadUrl}>
            <div
              className="tooltip-container"
              data-tooltip-content={item.label}
              data-tooltip-id="attachmentTooltip"
              data-delay-show={1000}
              tabIndex="-1"
            >
              <Button
                aria-label={t('download_file', { fileName: item.label })}
                secondary={true}
                onClick={() => downloadFile(item.downloadUrl)}
              >
                <FontAwesomeIcon icon={faDownload} />
                <span className="filename">{item.label}</span>
                <FileSize className="ct-video-attachments__size" size={item.size} />
              </Button>
            </div>
            <Tooltip
              id="attachmentTooltip"
              className="attachment-tooltip"
              place="top"
              effect="solid"
              type="dark"
              globalEventOff="click"
              multiline
              overridePosition={({ left, top }, _e, _t, node) => ({
                top,
                left: typeof node === 'string' ? left : Math.max(left, 10),
              })}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
